import { defineComponent as p, computed as l, createElementBlock as a, openBlock as n, mergeProps as u, unref as o, createCommentVNode as m, renderSlot as i, createTextVNode as f, toDisplayString as y } from "vue";
import s from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Banner/banner.js";
import { useOUIAProps as k } from "../helpers/ouia.js";
const B = {
  key: 0,
  class: "pf-v6-screen-reader"
}, $ = /* @__PURE__ */ p({
  name: "PfBanner",
  __name: "Banner",
  props: {
    sticky: { type: Boolean },
    screenReaderText: {},
    color: {},
    status: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(c) {
    const r = c, d = k({ id: r.ouiaId, safe: r.ouiaSafe }), t = l(() => r.status || r.color);
    return (e, v) => (n(), a("div", u({ ...o(d), ...e.$attrs }, {
      class: [o(s).banner, {
        [o(s).modifiers.sticky]: e.sticky,
        [o(s).modifiers[t.value]]: t.value
      }]
    }), [
      e.screenReaderText || e.$slots["screen-reader-text"] ? (n(), a("span", B, [
        i(e.$slots, "screen-reader-text", {}, () => [
          f(y(e.screenReaderText), 1)
        ])
      ])) : m("", !0),
      i(e.$slots, "default")
    ], 16));
  }
});
export {
  $ as default
};
